import type { ComponentType, PropsWithChildren, ReactNode } from "react";
import type React from "react";

import type { IButtonProps } from "@similarweb/ui-components";
import { Tooltip, Button } from "@similarweb/ui-components";

import { StyledSubmitButton } from "./styles";

export type ButtonComponentProps = Pick<IButtonProps, "isDisabled" | "isLoading" | "onClick" | "dataAutomation">;

type SubmitButtonProps = {
    onClick(): void;
    label: string;
    isDisabled?: boolean;
    isLoading: boolean;
    tooltipContent: ReactNode;
    dataAutomation?: string;
    ButtonComponent?: ComponentType<PropsWithChildren<ButtonComponentProps>>;
};

const SubmitButton: React.FC<SubmitButtonProps> = ({
    onClick,
    tooltipContent,
    label,
    isDisabled = false,
    isLoading,
    dataAutomation,
    ButtonComponent = Button,
}) => {
    const handleClick = () => {
        if (!isDisabled || !isLoading) {
            onClick();
        }
    };

    return (
        <Tooltip
            enabled={isDisabled}
            placement="top"
            content={tooltipContent}
        >
            <div>
                <StyledSubmitButton
                    isLoading={isLoading}
                    isDisabled={isDisabled}
                >
                    <ButtonComponent
                        isDisabled={isDisabled}
                        isLoading={isLoading}
                        onClick={handleClick}
                        dataAutomation={dataAutomation}
                    >
                        {label}
                    </ButtonComponent>
                </StyledSubmitButton>
            </div>
        </Tooltip>
    );
};

export default SubmitButton;
